import React, { lazy, Suspense } from 'react';
var LazyDatasourceTableView = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_linkdatasource-tableview" */'./datasourceTableView').then(function (module) {
    return {
      default: module.DatasourceTableView
    };
  });
});
var DatasourceTableViewWithWrappers = function DatasourceTableViewWithWrappers(props) {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", {
      "data-testid": 'datasource-table-view-suspense'
    })
  }, /*#__PURE__*/React.createElement(LazyDatasourceTableView, props));
};
export default DatasourceTableViewWithWrappers;